export const GET_ALL_NEWS_REQUEST = "GET_ALL_NEWS_REQUEST";
export const GET_ALL_NEWS_SUCCESS = "GET_ALL_NEWS_SUCCESS";
export const GET_ALL_NEWS_FAILURE = "GET_ALL_NEWS_FAILURE";
